import { AddIcon, DeleteIcon } from '@sketchnote/icons';
import { Dispatch, SetStateAction, useState } from 'react';

export const SubtaskCreation = ({
  subtasks,
  setSubtasks,
}: {
  subtasks: string[];
  setSubtasks: Dispatch<SetStateAction<string[]>>;
}) => {
  const [subtaskName, setSubtaskName] = useState('');
  const [canDelete, setCanDelete] = useState(false);

  const handleAddSubtask = () => {
    if (!subtaskName) return;
    setSubtasks((prev) => {
      return [subtaskName, ...prev];
    });
    setCanDelete(true);
    setSubtaskName('');
  };

  const handleDeleteSubtask = (index: number) => {
    setSubtasks((prev) => {
      return prev.filter((_, i) => i !== index);
    });
  };

  return (
    <div className="flex flex-col w-full mt-10">
      <div className="flex text-gray-600 items-center text-sm ">
        <input
          className="border border-gray-200 rounded-md px-9 py-6 bg-white w-full truncate"
          placeholder="Enter subtask name"
          autoFocus
          onChange={(e) => {
            setSubtaskName(e.target.value);
          }}
          value={subtaskName}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleAddSubtask();
            }
          }}
        />
        <AddIcon className="ml-6 text-gray-500" size={12} onClick={handleAddSubtask} />
      </div>
      <div className="flex flex-col grow max-h-200 overflow-y-scroll no-scrollbar mt-10 ">
        {subtasks.map((item, index) => {
          return (
            <div key={index} className="flex text-gray-600 w-full mb-10 items-center text-sm">
              <input
                className="border border-gray-200 rounded-md px-9 py-6 bg-white w-full truncate"
                value={item}
                disabled={true}
                placeholder="Subtask name"
                autoFocus
                onChange={(e) => {
                  setSubtaskName(e.target.value);
                }}
              />
              {canDelete && (
                <DeleteIcon
                  className="ml-6 text-gray-500"
                  size={14}
                  onClick={() => handleDeleteSubtask(index)}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
